import t from "./ghl-ui.es1169.js";
const e = () => t, o = {
  name: "Space",
  self: e
}, a = o;
export {
  a as default
};
